import axiosIns from '@/libs/axios'

const controller = 'relatorios'

export default {
  async getTipos() {
    return axiosIns.get(`${controller}/tipos`).then(res => res.data)
  },

  async getPontuacaoAlunos(escolaId) {
    return axiosIns.get(`${controller}/pontuacao-alunos?escolaId=${escolaId}`).then(res => res.data)
  },

  async downloadExcelUrl(escolaId) {
    return `${axiosIns.defaults.baseURL || ''}/api/${controller}/pontuacao-alunos/exportar-excel?escolaId=${escolaId}`
  },
}
